import UserWay from '@/components/userway/userway';
import { Box, Divider, Flex, FlexProps, Text } from '@cmpsr/components';

export default function Disclaimer(props: FlexProps) {
  return (
    <Flex
      w="100%"
      mx="auto"
      flexDir={{ base: 'column-reverse', lg: 'row' }}
      px={{ base: 5, md: 10 }}
      py={{ base: 5, md: 4 }}
      {...props}
    >
      <Flex flexDir="column" flex="1">
        <Text variant="text-body-floating-label-regular" color="text-secondary-negative">
          This site is offered for informational purposes only, and is not intended to be used as medical advice, or for
          diagnosis or treatment purposes.
        </Text>
        <Text variant="text-body-floating-label-regular" color="text-secondary-negative">
          Copyright © 2025 Catch Bio, Inc. - All Rights Reserved
        </Text>
      </Flex>
      <Box ml={{ base: 4, lg: 6 }} mr={{ base: 4, lg: 6 }}>
        <Divider orientation="vertical" height="100%" />
      </Box>
      <UserWay
        offsetConfig={{ base: '125px', md: '71px', lg: '53px' }}
        size="s"
        alignSelf={{ base: 'flex-start', lg: 'center' }}
        my={{ base: 3, lg: 0 }}
      />
    </Flex>
  );
}
